import { render, staticRenderFns } from "./HistoryPoint.vue?vue&type=template&id=ee81b1d0&scoped=true&"
import script from "./HistoryPoint.vue?vue&type=script&lang=js&"
export * from "./HistoryPoint.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPoint.vue?vue&type=style&index=0&id=ee81b1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee81b1d0",
  null
  
)

export default component.exports